import React from 'react'
import PropTypes from 'prop-types'

import { GlgTooltip } from 'Shared/components'

const ConfigInfo = ({ text }) => {
  return (<GlgTooltip tooltip={text}>
    <i className='gga-info-circle'/>
  </GlgTooltip>)
}

ConfigInfo.propTypes = {
  text: PropTypes.string.isRequired,
}

export default ConfigInfo
